import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import Container from '@app/components/General/Container'

const ModalComponent = ({btnText, open, title, buttons, closeFn, children}) => {
  const [_open, setOpen] = useState(open);

  React.useEffect(() => {
    setOpen(open);
  }, [open]);

  const showModal = () => {
    setOpen(true);
  };
  const handleCancel = () => {
    setOpen(false);

    if(closeFn){
      closeFn();
    }
  }

  return (
    <>
    {
        btnText ?
        <Button type="primary" onClick={showModal}>
            {btnText}
        </Button>:<></>
    }
    {
        (_open) && 
        <Modal title={title} open={_open} onCancel={handleCancel} footer={[
            <Button key="back" onClick={handleCancel}>
                Cancelar
            </Button>,
            ...buttons]}>
                <Container>
                    {children}
                </Container>
        </Modal>
    }
    </>
  );
};
export default ModalComponent;